<div class="red-line" *ngIf="redLineVisible"></div>
